import { ref, computed } from 'vue';
import { camelCase } from 'lodash';
import { productMetaFieldTransformer } from '@/components/shop/products/Product';
import * as Sentry from '@sentry/vue';

export const useHybridCompareData = async (productComparison) => {
  const { $shopifyProductsRequest } = useNuxtApp();

  const handles = productComparison.compareProducts.map((p) => p.shopifyHandle);

  let productList = ref([]);

  try {
    productList.value = (await $shopifyProductsRequest(handles))
      .map((product) => {
        return productMetaFieldTransformer(product);
      })
      .map((product) => {
        const cmsComparisonData = productComparison.compareProducts.find((p) => p.shopifyHandle === product.handle);

        if (cmsComparisonData.compareProductAttributes) {
          cmsComparisonData.compareProductAttributes.forEach((attribute) => {
            const key = camelCase(attribute.compareCategory[0].slug);
            const value = attribute.body;

            if (value) {
              product.comparison = { ...product.comparison, [key]: value };
            }
          });
        }

        return product;
      });
  } catch (e) {
    console.error('Failed to fetch Shopify products:', e);
    Sentry.captureException(e);
  }

  // Computed properties for rendering
  const compareAttributes = computed(() => {
    return productComparison?.compareFields.map((field) => {
      return {
        key: camelCase(field.slug),
        title: field.title,
      };
    });
  });

  return {
    compareAttributes,
    productList,
  };
};
